module.exports = __webpack_public_path__ + "img/2009.10.7a30e012.png";